export default "__VITE_ASSET__Be5WJeHU__"